var $1a9c827ca36d69a1$exports = {};
$1a9c827ca36d69a1$exports = {
    "replaceMessage": `\u{644}\u{644}\u{627}\u{633}\u{62A}\u{628}\u{62F}\u{627}\u{644}\u{60C} \u{642}\u{645} \u{628}\u{625}\u{641}\u{644}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{644}\u{641}`
};


export {$1a9c827ca36d69a1$exports as default};
//# sourceMappingURL=ar-AE.mjs.map
